import { css } from 'lit';
import utilities from './utilities.js';
import cCardHeader from './components/card-header.js';

export default css`
  ${utilities}
  ${cCardHeader}

  button:has(> rh-tag) {
    background: transparent;
    padding: 0px;
    margin: 0px;
    box-shadow: none;
    border: none;
  }

  button > rh-tag {
    text-decoration: underline;
  }

  button:where(:hover, :focus) rh-tag {
    --rh-border-width-sm: var(--rh-border-width-md, 2px);
  }

  .c-sub-header, .c-sub-header ::slotted(*) {
    font-family: var(--rh-font-family-heading, RedHatDisplay, 'Red Hat Display', Helvetica, Arial, sans-serif) !important;
    font-size: 16px !important;
    font-weight: var(--rh-font-weight-heading-medium, 500) !important;
    line-height: var(--rh-line-height-heading, 1.3) !important;
    margin: 0 !important;
    margin-block-end: var(--rh-space-lg, 16px) !important;
  }

  .c-list {
    list-style: none;
    padding: 0px;
    margin: 0;
    margin-block-end: var(--rh-space-xl, 24px); 
  }

  .c-list > .c-list__item:first-of-type {
    margin-block-start: 0;
  }

  .c-list__item:not(first-of-type) {
    margin-block-start: var(--rh-space-xl, 24px);
  }

  .c-list__link {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: var(--rh-color-accent-base-on-light, #06c);
  }

  .c-list__link:hover {
    text-decoration: underline;
  }

  .c-list__link > rh-icon {
    margin-inline-end: var(--rh-space-md, 8px);
    color: var(--rh-color-black, #000);
  }

  rh-dialog::part(dialog) {
    position: fixed;
  }

  /** FIX FOR PF POPOVER (MYRH-POPOVER) **/
  myrh-popover {
    --pf-c-popover__content--FontSize: 1rem;
    font-family: var(--rh-font-family-body, RedHatText, "Red Hat Text", Helvetica, Arial, sans-serif) !important;
    font-weight: 400;
    line-height: 0;
  }

  myrh-popover::part(content) {
    padding: 24px;
    min-width: 275px !important;
    width: fit-content !important;
  }

  @media screen and (max-width: 450px) {
    myrh-popover::part(content) {
      max-width: 14rem !important;
    }
  }
`;
